export default class Navigation {
  constructor(rootNode) {
    this.$refs = {
      rootNode,
      bodyElement: document.body,
      mobileToggle: document.body.querySelector('.MobileToggle'),
      mobileMenuBack: document.body.querySelector('.Header .mobile-menu-back'),
      subMenus: [
        ...rootNode.querySelectorAll('.has-items'),
      ],
    }

    this.init()
  }

  init() {
    this.initMobileToggle()

    this.initSubmenuLinks()

    this.initBackLink()
  }

  initMobileToggle() {
    this.$refs.mobileToggle.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.$refs.bodyElement.classList.contains('show-menu')) {
        this.closeSubMenu()
      }

      this.$refs.bodyElement.classList.toggle('show-menu')
    })
  }

  initSubmenuLinks() {
    Object.values(this.$refs.subMenus).forEach((subMenu) => {
      const link = subMenu.querySelector('a')

      link.addEventListener('click', (e) => {
        if (!this.mobileCondition()) return

        e.preventDefault()
        e.stopPropagation()

        this.showSubmenu(subMenu, link.textContent)
      })
    })
  }

  initBackLink() {
    this.$refs.mobileMenuBack.addEventListener('click', (e) => {
      if (!this.mobileCondition()) return

      e.preventDefault()
      e.stopPropagation()

      this.closeSubMenu()
    })
  }

  showSubmenu(link, text) {
    this.$refs.bodyElement.classList.add('show-sub-menu')

    this.$refs.mobileMenuBack.setAttribute('data-active-menu', text)

    link.classList.add('show-sub-menu-items')
  }

  mobileCondition() {
    return this.$refs.bodyElement.classList.contains('show-menu')
  }

  closeSubMenu() {
    const subMenus = this.$refs.bodyElement.querySelectorAll('.show-sub-menu-items')

    Object.values(subMenus).forEach((subMenu) => {
      subMenu.classList.remove('show-sub-menu-items')
    })

    this.$refs.bodyElement.classList.remove('show-sub-menu')
    this.$refs.mobileMenuBack.removeAttribute('data-active-menu')
  }
}
